import { BusinessLoginButton } from '@bridebook/web/app-basic/components/navigation-modal/business-login-button';
import { useBurgerMenuOptions } from '@bridebook/web/app-basic/components/navigation-modal/constants';
import { CoupleLoginButton } from '@bridebook/web/app-basic/components/navigation-modal/couple-login-button';
import { NestedNavigationList } from '@bridebook/web/app-basic/components/navigation-modal/nav-list/nested-navigation-list';
import { StickyBottomBar } from '@bridebook/web/app-basic/components/navigation-modal/sticky-bottom-bar';
import { type FC, useEffect } from 'react';

const TOP_OFFSET = 53;

interface IProps {
  isOpen: boolean;
  isSticky?: boolean;
}

export const NavigationModal: FC<IProps> = ({ isOpen, isSticky }) => {
  const menuOptions = useBurgerMenuOptions();
  const offsetY = typeof window !== 'undefined' ? window.scrollY : 0;
  // When not sticky, the portal follows the header as the page scrolls until the header is gone.
  const scrollBasedOffset = Math.max(TOP_OFFSET - offsetY, 0);

  useEffect(() => {
    // disable overflow of the page contents found underneath, also disable scrollbar
    if (typeof window !== 'undefined') {
      if (isOpen) {
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';
        document.body.style.top = `-${offsetY}px`;
      }

      return () => {
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.width = '';
        document.body.style.top = '';

        window.scrollTo(0, offsetY);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  return (
    <div
      className="bcm"
      data-open={isOpen}
      style={{
        top: isSticky ? TOP_OFFSET : scrollBasedOffset,
        height: `calc(100dvh - ${scrollBasedOffset}px)`,
      }}>
      <NestedNavigationList options={menuOptions} isOpen={isOpen} className="bcp" />
      <StickyBottomBar isOpen={isOpen}>
        <BusinessLoginButton />
        <CoupleLoginButton />
      </StickyBottomBar>
    </div>
  );
};
